import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
gsap.registerPlugin([ScrollTrigger, SplitText])

export const animation = () => {
    document.fonts.ready.then(() => {
        addClass()
        countUp()
        textHighlight()
        timeline()
    })
}

const addClass = () => {

    let els = document.querySelectorAll('[data-animation="add-class"]')

    if (!els.length) return

    els.forEach(el => {

        el.style.opacity = 1

        let trigger = el.parentElement

        gsap.to(el, {
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
                // markers: true,
                onEnter: () => {
                    el.classList.add('in-view')
                },
                onLeaveBack: () => {
                    el.classList.remove('in-view')
                },
            }
        })
    })
}

const countUp = () => {

    let els = document.querySelectorAll('[data-animation="count-up"]')

    if (!els.length) return

    els.forEach(el => {

        el.style.opacity = 1

        let start = el.getAttribute('data-start') ? parseInt(el.getAttribute('data-start')) : 100,
            end = el.getAttribute('data-end') ? parseInt(el.getAttribute('data-end')) : start * 0.75

        gsap.from(el, {
            textContent: start,
            duration: 6,
            ease: "power4.out",
            snap: { textContent: 1 },
            stagger: {
                each: 1.0,
                onUpdate: function () {
                    this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent))
                },
            },
            scrollTrigger: {
                trigger: el,
                start: 'top bottom',
                // markers: true,
            }
        })

        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }

    })
}

const textHighlight = () => {

    let els = document.querySelectorAll('[data-animation="text-highlight"]')

    if (!els.length || window.innerWidth < 782) return

    els.forEach(el => {
        const chars = el.querySelectorAll('.char')

        gsap.timeline({
            scrollTrigger: {
                trigger: el,
                pin: true,
                start: 'top top',
                end: '+=4000px',
                scrub: true
            }
        })
        .to(chars, {
            duration: 0.3,
            stagger: 0.2,
            opacity: 1
        })
    })
  
}

const timeline = () => {

    return

    const el = document.querySelector('.timeline')
    const track = el?.querySelector('.timeline__slider-track')
    const entries = el?.querySelectorAll('.timeline__entry')
    const pagination = el?.querySelector('.timeline__pagination')
  
    if (!el) return

    let proxy = { skew: 0 }
    const clamp = gsap.utils.clamp(-10, 10)
    const skewSetter = gsap.quickSetter(track, 'skewX', 'deg')
  
    console.log('length: ' + entries.length)
  
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        pin: true,
        start: 'top top',
        end: `+=${ entries.length + 2 }000px`,
        scrub: 1,
        onUpdate: self => {
              
          setActive((self.progress * entries.length + 1).toFixed(0))
          return
            let skew = clamp(self.getVelocity() / -300)

            if (Math.abs(skew) > Math.abs(proxy.skew)) {
                proxy.skew = skew;
                gsap.to(proxy, { skew: 0, duration: 0.8, ease: 'power3', overwrite: true, onUpdate: () => skewSetter(proxy.skew)})
            }
  
          // gsap.to(track, {
          //   duration: 0.1,
          //   skewX: `${self.getVelocity() / 400}deg`
          // })
        }
      }
    })
    tl.to(entries, {
      xPercent: -100 * (entries.length - 1),
      duration: 10,
      ease: 'none'
    })
  
    const setActive = (active) => {
      pagination.setAttribute('data-active', active)
    }
  }

export default () => { }